<template id="adminTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>
    <div v-if="!unauthorized" class="main-div" :class="formState.invalidShake?'invalid':''">
      <small
        class="--centered-block"
        v-if="(newAdmin==null)"
      >Select a Admin From the list to edit. Press the Add New Button to add a new Admin</small>
      <div class="form-group col-12 col-sm-12" v-if="newAdmin==null">
        <label class="pl-0 col-12 col-sm-12" for="admins">All Admins</label>
        <div class="p-0 mb-4 col-12 col-sm-12">
          <input
            class="form-control"
            type="text"
            maxlength="200"
            placeholder="Search All admins"
            v-model="adminsSearch"
          />
        </div>
        <b-form-select
          :disabled="formState.loading"
          class="col-12 col-sm-12"
          style="font-size:16px;"
          v-model="selectedAdminId"
          :options="filteredAdmins"
          :select-size="+10"
        ></b-form-select>
      </div>

      <div
        v-if="errors.length && formState.attempted && (!formState.loading)"
        class="col-12 col-sm-12"
      >
        <b class="w-100">Please correct the following error(s):</b>
        <ul>
          <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
        </ul>
      </div>

      <form class="admin-form">
        <fieldset
          :disabled="formState.loading"
          class="p-0 col-12 col-sm-12"
          v-if="(newAdmin==null)&&selectedAdminData"
        >
          <legend>Existing Admin's Data</legend>
          <div class="row">
            <legend>Personal Data</legend>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="name">Name</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="25"
                v-model="selectedAdminData.name"
                placeholder="ex. Mohammed"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="mobile">Mobile</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="number"
                maxlength="14"
                v-model="selectedAdminData.mobile"
                placeholder="ex. 00966XXXX"
              />
            </div>
            <hr style="display: block;width: 100%;" />
            <legend>Credential Data</legend>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="email">Email</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="email"
                v-model="selectedAdminData.email"
                placeholder="ex. admin@ithoob.com"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="role">Role</label>
              <b-form-select
                :disabled="formState.loading"
                class="modified-dropdown col-12 col-sm-8"
                v-model="selectedAdminData.role"
                :options="adminsRoles"
              ></b-form-select>
            </div>
            <div class="form-group col-12 col-sm-12">
              <button
                type="button"
                v-on:click="togglePasswordEdit"
                :class="selectedAdminData.editPassword?'btn btn-info':'btn btn-danger'"
                :disabled="formState.loading"
              >{{selectedAdminData.editPassword?"Cancel Password Editing":"Click To Edit Password"}}</button>
            </div>
            <div class="form-group col-12 col-sm-12" v-if="selectedAdminData.editPassword">
              <label class="pl-0 col-12 col-sm-4" for="password">Password</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="password"
                maxlength="16"
                v-model="selectedAdminData.password"
                placeholder="ex. password"
              />
              <label class="pl-0 col-12 col-sm-4" for="password">Confirm Password</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="password"
                maxlength="16"
                v-model="selectedAdminData.confirmPassword"
                placeholder="ex. Confirm Password"
              />
            </div>
          </div>
        </fieldset>
        <hr style="display: block;width: 100%;" />
        <div class="form-group col-12 col-sm-12">
          <div class="form-group col-12 col-sm-6" v-if="(newAdmin==null)&&selectedAdminData">
            <button
              type="button"
              v-on:click="deleteAdmin()"
              class="btn btn-danger"
              :disabled="formState.loading"
            >Delete Selected admin</button>
          </div>
          <div class="form-group col-12 col-sm-6" v-if="(newAdmin==null)&&selectedAdminData">
            <button
              :disabled="formState.loading"
              type="button"
              v-on:click="commitChanges()"
              class="btn btn-info"
            >Confirm Changes</button>
          </div>
        </div>

        <fieldset
          :disabled="formState.loading"
          class="p-0 col-12 col-sm-12"
          v-if="(newAdmin!=null)"
        >
          <legend>New Admin's Data</legend>
          <div class="row">
            <legend>Personal Data</legend>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="name">Name</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="25"
                v-model="newAdmin.name"
                placeholder="ex. Mohammed"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="mobile">Mobile</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="number"
                maxlength="14"
                v-model="newAdmin.mobile"
                placeholder="ex. 00966XXXX"
              />
            </div>
            <hr style="display: block;width: 100%;" />
            <legend>Credential Data</legend>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="email">Email</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="email"
                maxlength="200"
                v-model="newAdmin.email"
                placeholder="ex. admin@ithoob.com"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="role">Role</label>
              <b-form-select
                :disabled="formState.loading"
                class="modified-dropdown col-12 col-sm-8"
                v-model="newAdmin.role"
                :options="adminsRoles"
              ></b-form-select>
            </div>
            <div class="form-group col-12 col-sm-12">
              <label class="pl-0 col-12 col-sm-4" for="password">Password</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                maxlength="16"
                type="password"
                v-model="newAdmin.password"
                placeholder="ex. password"
              />
              <label class="pl-0 col-12 col-sm-4" for="password">Confirm Password</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="password"
                maxlength="16"
                v-model="newAdmin.confirmPassword"
                placeholder="ex. Confirm Password"
              />
            </div>
          </div>
        </fieldset>

        <div class="col-12 col-sm-12" v-if="newAdmin!=null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="saveNewAdmin()"
            class="btn btn-info"
          >Save New Admin</button>
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="cancelNewAdmin()"
            class="btn btn-danger"
          >Cancel New Admin</button>
        </div>

        <div class="col-12 col-sm-12" v-if="newAdmin==null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="addNewAdmin()"
            class="m-0 btn btn-success"
          >Add New Admin</button>
        </div>
      </form>
    </div>
  </div>
</template>



<!-- admin Template -->




<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  padding: 50px;
  width: 80%;
  div {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
  }

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }

  .--centered-block {
    margin: 0 auto;
  }
}

//  0.82s
.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
import { setTimeout } from "timers";
/* eslint-enable no-unused-vars*/

import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "adminsCRUD",
  data() {
    return {
      unauthorized: false,
      newAdmin: null, // If add admin button is pressed, this will be an object with a name, a domain and a discount.
      adminsSearch: "", // We search All admins Depending on this.
      selectedAdminId: null, // Specifies The Id of the selected admin in the database
      selectedAdminData: null, // Data is fetched from the backend using selectedAdminId
      admins: [{ value: null, text: "Please select a admin to edit" }], // All admins (Fetched When component is mounted)
      filteredAdmins: [{ value: null, text: "Please select a admin to edit" }], // All admins Filtered Using adminsSearch
      errors: [], // Form's errors
      adminsRoles: [
        { value: "general", text: "General" },
        { value: "super", text: "Super" }
      ],
      adminsData: {},
      formState: {
        loading: false,
        attempted: false,
        invalidShake: false
      } // Object Determining the Form's state
    };
  },
  watch: {
    // Computes the Filtered Array out of admins fetched from backend.
    adminsSearch: function() {
      this.filteredAdmins = this.admins.filter(str => {
        return this.adminsSearch == ""
          ? true
          : str.text.toLowerCase().includes(this.adminsSearch.toLowerCase());
      });
      if (this.filteredAdmins.length < 1)
        this.filteredAdmins = [{ value: null, text: "No such result" }];
    },
    // When selectedAdminId is changed, the admin's Data is fetched from the backend, If null is selected, the form is reset.
    selectedAdminId: function() {
      if (this.selectedAdminId) {
        this.selectedAdminData = { ...this.adminsData[this.selectedAdminId] };
        this.selectedAdminData.editPassword = false;
      } else {
        this.partiallyResetForm();
      }
    },
    newAdmin: function() {
      this.checkForm();
    },
    selectedAdminData: function() {
      this.checkForm();
    }
  },
  mounted() {
    this.fetchAlladmins();
  },
  methods: {
    togglePasswordEdit: function() {
      if (this.selectedAdminData.editPassword) {
        this.selectedAdminData = {
          ...this.selectedAdminData,
          editPassword: false,
          password: null,
          confirmPassword: null
        };
      } else {
        this.selectedAdminData = {
          ...this.selectedAdminData,
          editPassword: true,
          password: "",
          confirmPassword: ""
        };
      }
    },
    // Partially resets the form
    partiallyResetForm: function() {
      this.cancelNewAdmin();
      this.selectedAdminData = null;
      this.selectedAdminId = null;
      this.errors = [];
      this.formState = {
        loading: false,
        attempted: false,
        invalidShake: false
      };
    },
    checkForm: function() {
      this.errors = [];
      const emailRegex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      const mobileRegex = /^[0-9]*$/i;
      if (this.newAdmin) {
        if (!this.newAdmin.name) {
          this.errors.push("Admin's Name is required");
        }
        if (this.newAdmin.name && this.newAdmin.name.length < 3) {
          this.errors.push("Admin's Name minimum length is 3");
        }
        if (!this.newAdmin.email) {
          this.errors.push("Admin's Email is required");
        }
        if (!emailRegex.test(this.newAdmin.email)) {
          this.errors.push("Admin's Email format is incorrect");
        }
        if (!this.newAdmin.password) {
          this.errors.push("Admin's Password is required");
        }
        if (this.newAdmin.password && this.newAdmin.password.length < 8) {
          this.errors.push("Admin's Password minimum length is 8");
        }
        if (this.newAdmin.confirmPassword != this.newAdmin.password) {
          this.errors.push("Passwords don't match");
        }
        if (
          this.newAdmin.mobile &&
          (this.newAdmin.mobile.length < 9 || this.newAdmin.mobile.length > 14)
        ) {
          this.errors.push("Admin's Mobile length is between 9 and 14 numbers");
        }
        if (this.newAdmin.mobile && !mobileRegex.test(this.newAdmin.mobile)) {
          this.errors.push("Admin's Mobile should be numbers only");
        }
      } else if (this.selectedAdminData) {
        if (!this.selectedAdminData.name) {
          this.errors.push("Admin's Name is required");
        }
        if (
          this.selectedAdminData.name &&
          this.selectedAdminData.name.length < 3
        ) {
          this.errors.push("Admin's Name minimum length is 3");
        }
        if (!this.selectedAdminData.email) {
          this.errors.push("Admin's Email is required");
        }
        if (!emailRegex.test(this.selectedAdminData.email)) {
          this.errors.push("Admin's Email format is incorrect");
        }
        if (this.selectedAdminData.editPassword) {
          if (!this.selectedAdminData.password) {
            this.errors.push("Admin's Password is required");
          }
          if (
            this.selectedAdminData.confirmPassword !=
            this.selectedAdminData.password
          ) {
            this.errors.push("Passwords don't match");
          }
          if (this.selectedAdminData.password.length < 8) {
            this.errors.push("Admin's Password minimum length is 8");
          }
        }
        if (
          this.selectedAdminData.mobile &&
          (this.selectedAdminData.mobile.length < 9 ||
            this.selectedAdminData.mobile.length > 14)
        ) {
          this.errors.push("Admin's Mobile length is between 9 and 14 numbers");
        }
        if (
          this.selectedAdminData.mobile &&
          !mobileRegex.test(this.selectedAdminData.mobile)
        ) {
          this.errors.push("Admin's Mobile should be numbers only");
        }
      }
    },
    fetchAlladmins() {
      this.formState.loading = true;
      return axios
        .get(`${herokuUrl}/dashboard/admins`, {
          headers: {
            Authorization: getCookie("user")
          }
        })
        .then(res => {
          this.admins = [
            { value: null, text: "Please select a admin to edit" }
          ];
          this.adminsData = {};
          res.data.admins.forEach(element => {
            this.admins.push({
              text: element.name,
              value: element.id
            });
            let num = +element.id;
            this.adminsData[num] = { ...element };
          });
          this.filteredAdmins = [...this.admins];
          this.formState.loading = false;
        })
        .catch(err => {
          this.formState.loading = false;
          if(err.response.status == 401) {
            this.unauthorized = true;
            alert("Unauthorized, please refer to a super admin to edit admins");
          } else {
            alert("Admins fetching failed, " + err.response.data.message);
          }

          // window.location.reload();
        });
    },
    deleteAdmin() {
      if (confirm("Please confirm you want to DELETE the selected admin")) {
        this.formState.loading = true;
        return axios
          .delete(
            `${herokuUrl}/dashboard/deleteAdmin/${this.selectedAdminData.id}`,
            {
              headers: {
                Authorization: getCookie("user")
              }
            }
          )
          .then(() => {
            alert("admin was deleted successfully");
            this.partiallyResetForm();
            this.fetchAlladmins();
          })
          .catch(err => {
            if(err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(err.response.data.message);
            }
          });
      }
    },
    commitChanges() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (
          confirm(
            "Please confirm you want to UPDATE the selected admin with the new data"
          )
        ) {
          this.formState.loading = true;
          return axios
            .put(
              `${herokuUrl}/dashboard/editAdmin/${this.selectedAdminData.id}`,
              {
                ...this.selectedAdminData,
                password: this.selectedAdminData.editPassword
                  ? this.selectedAdminData.password
                  : undefined
              },
              {
                headers: {
                  Authorization: getCookie("user")
                }
              }
            )
            .then(() => {
              alert("admin was Edited successfully");
              this.partiallyResetForm();
              this.fetchAlladmins();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected admin " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function() {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    },
    addNewAdmin() {
      this.newAdmin = {
        name: "",
        email: "",
        role: "general",
        password: "",
        confirmPassword: "",
        mobile: ""
      };
    },
    cancelNewAdmin() {
      this.newAdmin = null;
    },
    saveNewAdmin() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (confirm("Please confirm you want to Add a new admin")) {
          this.formState.loading = true;
          return axios
            .post(`${herokuUrl}/dashboard/addAdmin`, this.newAdmin, {
              headers: {
                Authorization: getCookie("user")
              }
            })
            .then(() => {
              alert("admin was Added successfully");
              this.partiallyResetForm();
              this.fetchAlladmins();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                if (String(err.response.data.message).includes("unique"))
                  alert(
                    "There was a problem adding the new admin, Email has to be unique. "
                  );
                else
                  alert(
                    "There was a problem adding the new admin " +
                      err.response.data.message
                  );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    }
  },
  components: {
    appNavigation: Navigation
  }
};
</script>
